import cn from 'classnames';
import styled from 'styled-components';

import { Member } from '@/entities/vfo/types';
import { CASE_BACKGROUND_STYLES, CaseBackground } from '@/features/vfo/constants';
import { ApiCaseResponseV2 } from '@/shared/api';
import { COLORS } from '@/shared/constants/colors';
import { BFC } from '@/shared/types';
import { Icon } from '@/shared/uikit/Icon';

import { Avatar } from './Avatar';
import { UnreadCount } from './UnreadCount';

type CaseIconProps = {
  onClick?: () => void;
  size?: 's80' | 's44' | 's36';
  member?: Member;
  caseData?: ApiCaseResponseV2;
  unreadCount?: number;
};

const iconSizes = {
  s80: 's44',
  s44: 's24',
  s36: 's20',
} as const;

export const CaseIcon: BFC<CaseIconProps> = ({
  onClick,
  size = 's36',
  member,
  caseData,
  unreadCount,
  className,
  style,
  ...props
}) => {
  const caseStyles = caseData
    ? CASE_BACKGROUND_STYLES[caseData.background]
    : CASE_BACKGROUND_STYLES[CaseBackground.Archive];

  return (
    <CaseIconStyles
      onClick={onClick}
      className={cn({ [size]: size }, className)}
      style={{
        background: caseStyles?.background,
        color: caseStyles?.iconColor,
        ...style,
      }}
      {...props}
    >
      {member ? (
        <Avatar showStatus member={member} size={size} />
      ) : (
        <Icon
          name={caseData?.isGeneralCase ? 'folder-star' : caseStyles?.icon}
          size={iconSizes[size]}
        />
      )}

      {Boolean(unreadCount) && <UnreadCount>{unreadCount}</UnreadCount>}
    </CaseIconStyles>
  );
};

export const CaseIconStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${COLORS.systemSky100};
  color: ${COLORS.systemSky200};
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 100%;
  position: relative;
  cursor: pointer;

  &.s44 {
    width: 44px;
    height: 44px;
  }

  &.s80 {
    width: 80px;
    height: 80px;
  }
`;
